import { CreateColumn } from '../../../../../Services/agGrid/createColumn';

/**
 * RIS_BASIC_CUSTOM — 표준모델 요인 추가 모달 그리드 컬럼 (RIS_BASIC_01 getColumnDefs3와 동일 구성,
 * preferNodeRowData는 퀵필터 시 행 정렬 불일치 대응으로 이 모듈에서만 true 고정)
 */
export const GetRiskAssessmentStandardModelColumnDefs = (props) => [
  CreateColumn('no', 'NO', 'left', 100, false, false, false, 'checkbox', {
    checkboxProps: {
      DeleteNewRow1: null,
      RestoreRow1: null,
      gridRef1: props.gridRef5,
      rowData1: props.modalRowData4,
      selectedRowNosRef: props.selectedModalRowNosRef4,
      lastCheckedIndexRef: props.lastCheckedIndexRef3,
      handleRowSelection: props.handleRowSelection3,
      preferNodeRowData: true,
    },
    maxWidth: 100,
  }),
  CreateColumn('depNm', '공정명', 'left', 200, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
    wrapText: true,
    autoHeight: true,
    flex: 1,
    customCellStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      textAlign: 'left',
      width: '100%',
      height: '100%',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      lineHeight: 1.35,
    },
  }),
  CreateColumn(
    'categoryComment',
    '위험발생 및 결과',
    'left',
    400,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
      wrapText: true,
      autoHeight: true,
      flex: 1,
      customCellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'left',
        width: '100%',
        height: '100%',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        lineHeight: 1.35,
      },
    }
  ),
  CreateColumn(
    'sttLprvsTtlNm',
    '관련근거',
    'left',
    280,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
      wrapText: true,
      autoHeight: true,
      flex: 1,
      customCellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'left',
        width: '100%',
        height: '100%',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        lineHeight: 1.35,
      },
    }
  ),
  CreateColumn(
    'condolenceNo',
    '조문번호',
    'left',
    120,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
      wrapText: true,
      autoHeight: true,
      customCellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'left',
        width: '100%',
        height: '100%',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        lineHeight: 1.35,
      },
    }
  ),
];
